import { Link } from 'react-router-dom'

/**
 * QSAVE-brand footer — dark band with link columns (bitcoin.org-style),
 * from the approved editorial prototype (variant B). Rendered by Footer.tsx
 * when the active brand is QSAVE; other brands keep the standard footer.
 */

function Col({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h4 className="text-[14px] font-semibold text-[#f0eee4] mb-4 tracking-[0.01em]">{title}</h4>
      <ul className="space-y-[11px] list-none">{children}</ul>
    </div>
  )
}

function FLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <li>
      <Link to={to} className="text-[#b6b3a7] text-[14.5px] hover:text-white transition-colors">
        {children}
      </Link>
    </li>
  )
}

export function QsaveFooter() {
  return (
    <footer className="bg-qfooter font-sans mb-12">
      <div className="max-w-[1060px] mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.7fr_1fr_1fr_1fr_1fr] gap-10 lg:gap-12 pt-16 pb-14">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="block font-charter text-[22px] tracking-[0.02em] text-[#f0eee4] mb-4">
              QSAVE
            </span>
            <p className="text-[14px] leading-[1.6] text-[#b6b3a7] max-w-[30em]">
              QSAVE is a multi-chain, open-source protocol for handling cryptocurrency as the transition to
              post-quantum cryptography progresses. Bitcoin is the first implementation track; Ethereum and
              EVM implementations follow.
            </p>
          </div>
          <Col title="Protocol:">
            <FLink to="/register">Coin Registration</FLink>
            <FLink to="/recovery">How recovery works</FLink>
            <FLink to="/about">About</FLink>
            <FLink to="/faq">FAQ</FLink>
          </Col>
          <Col title="Foundation:">
            <FLink to="/philanthropic-foundation">Philanthropic Foundation</FLink>
            <FLink to="/contact">Contact</FLink>
          </Col>
          <Col title="Documents:">
            <li>
              <a
                href="/whitepapers/qsave-whitepaper-public.pdf"
                className="text-[#b6b3a7] text-[14.5px] hover:text-white transition-colors"
              >
                Whitepaper (PDF)
              </a>
            </li>
            <FLink to="/docs/viewer/qsave-participant-terms">Participant Terms</FLink>
            <FLink to="/terms">Website Terms</FLink>
            <FLink to="/privacy">Privacy</FLink>
          </Col>
        </div>
        <div className="border-t border-white/[0.13] pt-[26px] pb-10">
          <p className="text-[13px] text-[#b6b3a7]">&copy; 2026 QSAVE</p>
        </div>
      </div>
    </footer>
  )
}
